const data = {
  gutterBottom: {
    marginBottom: 8
  }
};
export default data;
